import React from 'react';
import { motion } from 'framer-motion';
import { EyeOff } from 'lucide-react';
export function HookSection() {
  return <section className="bg-brand-navy text-brand-cream py-20 px-4" data-id="element-67">
      <div className="max-w-3xl mx-auto" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center" data-id="element-69">
          <div className="w-16 h-16 bg-brand-gold/20 rounded-full flex items-center justify-center mb-8" data-id="element-70">
            <EyeOff className="w-8 h-8 text-brand-gold" data-id="element-71" />
          </div>

          <p className="text-xl md:text-2xl leading-relaxed font-serif" data-id="element-72">
            "¿Alguna vez has sentido ese nudo en el estómago al ver a tu hijo{' '}
            <strong className="text-brand-gold font-bold" data-id="element-73">
              "zombie" frente a una pantalla
            </strong>
            , ignorando tu voz, mientras tú solo intentas descansar un poco tras
            un día agotador?"
          </p>

          <div className="w-24 h-1 bg-brand-gold/50 mx-auto my-10 rounded-full" data-id="element-74"></div>

          <p className="text-lg md:text-xl text-brand-cream/90 leading-relaxed" data-id="element-75">
            No estás sola. Lo que estás viendo no es mala educación, es una{' '}
            <strong className="text-white" data-id="element-76">
              respuesta biológica a una tecnología diseñada para ser adictiva
            </strong>
            . Pero hay una solución que nadie te está contando.
          </p>
        </motion.div>
      </div>
    </section>;
}